/**
 * Custom abstract airco-derived line-art icons for Breuer Klimaattechniek.
 * Style: clean stroke-based, consistent with brand identity.
 */

interface IconProps {
	className?: string;
}

/** Airco unit with airflow arrows — represents "Home / Full offering" */
export function AircoHomeIcon({ className = 'size-14' }: IconProps) {
	return (
		<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
			{/* Airco unit body */}
			<rect x="8" y="12" width="48" height="20" rx="3" stroke="currentColor" strokeWidth="2.5" />
			{/* Vent slats */}
			<line x1="16" y1="26" x2="48" y2="26" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
			<line x1="16" y1="22" x2="48" y2="22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
			{/* Airflow curves */}
			<path d="M20 38 C20 44, 16 48, 16 54" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none" />
			<path d="M32 38 C32 44, 32 48, 32 54" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none" />
			<path d="M44 38 C44 44, 48 48, 48 54" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none" />
		</svg>
	);
}

/** Airco unit with wrench overlay — represents "Onderhoud & Service" */
export function AircoServiceIcon({ className = 'size-14' }: IconProps) {
	return (
		<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
			{/* Airco unit body */}
			<rect x="8" y="10" width="48" height="20" rx="3" stroke="currentColor" strokeWidth="2.5" />
			{/* Vent slats */}
			<line x1="16" y1="24" x2="48" y2="24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
			<line x1="16" y1="20" x2="48" y2="20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
			{/* Wrench */}
			<path
				d="M42 36 C46 32, 52 33, 54 37 C54.5 38, 54 39, 53 39 L44 48 C43 49, 42 49, 41 48 L39 46 C38 45, 38 44, 39 43 Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinejoin="round"
				fill="none"
			/>
			{/* Hand underneath */}
			<path
				d="M12 42 C14 38, 20 36, 24 38 C26 39, 28 42, 26 44 C24 46, 18 48, 14 47 C12 46, 11 44, 12 42Z"
				stroke="currentColor"
				strokeWidth="2"
				fill="none"
			/>
			<path d="M14 47 C12 50, 10 52, 10 54" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
		</svg>
	);
}

/** Airco unit with lightbulb/spark — represents "Advies & Inspiratie" */
export function AircoAdviesIcon({ className = 'size-14' }: IconProps) {
	return (
		<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
			{/* Airco unit body */}
			<rect x="8" y="18" width="48" height="20" rx="3" stroke="currentColor" strokeWidth="2.5" />
			{/* Vent slats */}
			<line x1="16" y1="32" x2="48" y2="32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
			<line x1="16" y1="28" x2="48" y2="28" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
			{/* Lightbulb above */}
			<circle cx="32" cy="8" r="5" stroke="currentColor" strokeWidth="2" />
			<line x1="32" y1="13" x2="32" y2="16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
			{/* Spark lines */}
			<line x1="24" y1="5" x2="22" y2="3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
			<line x1="40" y1="5" x2="42" y2="3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
			<line x1="32" y1="1" x2="32" y2="-1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
			{/* Soft airflow */}
			<path d="M24 44 C24 48, 22 52, 22 56" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.4" />
			<path d="M40 44 C40 48, 42 52, 42 56" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.4" />
		</svg>
	);
}
